$('.two-layer-slider').slick({
  slidesToShow: 5,
  slidesToScroll: 5,
  arrows: true,
  fade: false,
  dots: false,
  infinite: false,
  swipeToSlide: true,
  speed: 100,
  touchThreshold: 100,
  waitForAnimate: false,
  responsive: [
    {
      breakpoint: 900,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        arrows: true
      }
    },
    {
      breakpoint: 641,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true
      }
    }
  ]
});
